import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Materials from "./Materials";
import PageTransition from "../components/ui/PageTransition";
import { Loader2 } from "lucide-react";

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, isAuthLoading } = useAuth();

  useEffect(() => {
    if (!isAuthLoading && isAuthenticated && user) {
      if (user.role === "customer") {
        navigate("/customer-dashboard", { replace: true });
      } else if (user.role === "supplier") {
        navigate("/supplier-dashboard", { replace: true });
      }
    }
  }, [isAuthenticated, user, isAuthLoading, navigate]);

  if (isAuthLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white dark:bg-gray-900">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <PageTransition>
      {/* Hero Section */}
      <div
        className="w-full h-[65vh] md:min-h-[85vh] bg-cover bg-center relative"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/building.jpg)` }}
      >
        <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-white text-center px-6">
          <h1 className="text-2xl sm:text-4xl md:text-5xl font-extrabold mb-3 drop-shadow-md leading-tight">
            The One-Stop
            <span className="block sm:inline"> Platform for Constructions</span>
          </h1>
          <p className="text-sm sm:text-lg md:text-xl font-medium italic mb-2 text-gray-200 drop-shadow-sm">
            From Ground Levelling to Government Approvals
          </p>
          <strong className="text-sm sm:text-lg md:text-xl font-bold tracking-wide block mt-2">
            Connecting Core and Code
          </strong>
        </div>
      </div>

      {/* Category Showcase */}
      <Materials />
      <hr className="border-gray-200 dark:border-gray-700" />
    </PageTransition>
  );
};

export default Home;
